import { Card, CardProps, styled } from "@mui/material";
import { rgba } from "polished";
import React from "react";
interface IAquariusBorderedCardProps extends CardProps {
  isMobile: boolean;
}

export const AquariusBorderedCard = styled(({ isMobile, ...props }: IAquariusBorderedCardProps) => (
  <Card {...props} />
))<{
  isMobile: boolean;
}>`
  background: transparent;
  border: ${props => props.theme.modernSmallCardBorderWidth}px solid
    ${props => props.theme.modernSmallCardBorderColor};
  border-radius: ${props => props.theme.modernSmallCardBorderRadius}px !important;
  box-shadow: none;
  height: 100%;
  min-height: 150px;
  padding: 15px;
  transition: 0.3s ease-in-out;
  width: ${props => (props.isMobile ? "100%" : "295px")};

  :hover {
    background-color: ${props => rgba(props.theme.modernPageBackground!, 0.7)};
    cursor: pointer;
  }
`;
